import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class SEp2 extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Special Ep 6: Ramen, Rich People, Clubbing — Q and A!</h1>
                        <h5 className="korean-title">특별 에피소드 6: 질문/답</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

재벌 (jae bol) — rich people/families who own large conglomerates <br></br>

<br></br>
보자기 (bo ja gi) — a square cloth that is usually used to wrap something (pictured below)<br></br>
<img className="epPic-m" src="http://image.koreatimes.com/photos/LosAngeles/20140106/001.jpg"></img><br></br>
<img className="epPic-m" src="https://images.squarespace-cdn.com/content/v1/586ebc34d482e9c69268b69a/1487641598980-67XNXIP1UOTAJV17N26Q/image-asset.jpeg?format=1000w"></img><br></br>
<img className="epPic-m" src="https://newsimg.hankookilbo.com/cms/articlerelease/2021/04/09/570facc1-cf90-4be6-8661-fd9047a9cf4d.jpg"></img><br></br>


<br></br>
라면 (ra myun) — ramen (the typical Korean instant ramen is pictured below)<br></br>
<img className="epPic-m" src="https://health.chosun.com/site/data/img_dir/2020/09/07/2020090702900_0.jpg"></img><br></br>
신라면, 너구리, 진라면, 불닭볶음면 — names of popular Korean ramen brands <br></br>
Pictured below is 불닭볶음면, which went viral internationally for being very spicy instant noodles: <br></br>
<img className="epPic-m" src="https://contents.lotteon.com/itemimage/_v093718/LM/88/01/07/31/40/57/8_/00/1/LM8801073140578_001_1.jpg/dims/resizef/720X720"></img><br></br>


                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <SEp2></SEp2>
        </div>
    );
}


  const Sepisode2 = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Sepisode2;